import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = { key: 6 }
const _hoisted_7 = { key: 7 }
const _hoisted_8 = { key: 8 }
const _hoisted_9 = { key: 9 }
const _hoisted_10 = { key: 10 }
const _hoisted_11 = { class: "py-2 mt-4 editor__container" }
const _hoisted_12 = { class: "d-flex align-stretch" }
const _hoisted_13 = { class: "d-flex flex-column editor__container__options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_InvoiceMailTemplatesSetting = _resolveComponent("InvoiceMailTemplatesSetting")!
  const _component_SingleLineMailEditor = _resolveComponent("SingleLineMailEditor")!
  const _component_MultiLineMailEditor = _resolveComponent("MultiLineMailEditor")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_MailOptions = _resolveComponent("MailOptions")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select_filled, {
              label: "Type de mail",
              modelValue: _ctx.mailView,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mailView) = $event)),
              items: _ctx.mailItems,
              "item-value": "value",
              outlined: "",
              density: "compact",
              "item-title": "title",
              class: "pb-4",
              "data-cy": "InvoiceMailSetting-mailType"
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" })
      ]),
      _: 1
    }),
    (_ctx.mailView == 0)
      ? (_openBlock(), _createBlock(_component_InvoiceMailTemplatesSetting, {
          key: 0,
          defaultMails: _ctx.defaultMails,
          onTemplateDelete: _ctx.onMailTemplateDeleted
        }, null, 8, ["defaultMails", "onTemplateDelete"]))
      : _createCommentVNode("", true),
    (_ctx.mailView == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SingleLineMailEditor, {
            isSignature: false,
            modelValue: _ctx.defaultMails.invoice,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.defaultMails.invoice) = $event))
          }, null, 8, ["modelValue"])
        ]))
      : (_ctx.mailView == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_SingleLineMailEditor, {
              isSignature: false,
              modelValue: _ctx.defaultMails.quote,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.defaultMails.quote) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : (_ctx.mailView == 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_SingleLineMailEditor, {
                isSignature: false,
                modelValue: _ctx.defaultMails.deliveryBill,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.defaultMails.deliveryBill) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : (_ctx.mailView == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_SingleLineMailEditor, {
                  isSignature: false,
                  modelValue: _ctx.defaultMails.creditNote,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.defaultMails.creditNote) = $event))
                }, null, 8, ["modelValue"])
              ]))
            : (_ctx.mailView == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_SingleLineMailEditor, {
                    isSignature: false,
                    modelValue: _ctx.defaultMails.deposit,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.defaultMails.deposit) = $event))
                  }, null, 8, ["modelValue"])
                ]))
              : (_ctx.mailView == 5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_SingleLineMailEditor, {
                      isSignature: false,
                      modelValue: _ctx.defaultMails.reminder1,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.defaultMails.reminder1) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : (_ctx.mailView == 6)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_SingleLineMailEditor, {
                        isSignature: false,
                        modelValue: _ctx.defaultMails.reminder2,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.defaultMails.reminder2) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_ctx.mailView == 7)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_SingleLineMailEditor, {
                          isSignature: false,
                          modelValue: _ctx.defaultMails.reminder3,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.defaultMails.reminder3) = $event))
                        }, null, 8, ["modelValue"])
                      ]))
                    : (_ctx.mailView == 8)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_MultiLineMailEditor, {
                            modelValue: _ctx.defaultMails.multipleReminder,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.defaultMails.multipleReminder) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : (_ctx.mailView == 9)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_MultiLineMailEditor, {
                              modelValue: _ctx.defaultMails.delay,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.defaultMails.delay) = $event))
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _cache[14] || (_cache[14] = _createElementVNode("label", {
        for: "mailSignature",
        class: "editor__container__label"
      }, "Signature du mail", -1)),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Editor, {
          modelValue: _ctx.defaultMails.signature,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.defaultMails.signature) = $event)),
          ref: "signatureEditor",
          id: "mailSignature",
          class: "flex-grow-1",
          editorContentDataCy: 'SingleLineMailEditor-mailSignature'
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_MailOptions, {
            text: _ctx.defaultMails.signature,
            "onUpdate:text": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.defaultMails.signature) = $event)),
            reference: "signatureEditor",
            onOnMailOptionSelected: _ctx.updateSignature
          }, null, 8, ["text", "onOnMailOptionSelected"]),
          _createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-redo-alt",
              size: "small",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.defaultMails.signature = ''))
            }, null, 512), [
              [_directive_tooltip, 'Remettre les valeurs par défauts', "bottom"]
            ])
          ])
        ])
      ])
    ])
  ]))
}